import { defineMessages } from 'react-intl';

export const triageAgentRecommendationMessages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	setUpIn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chooseProject: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'jira-triage-agent-recommendation.title',
		defaultMessage: 'Triage new work automatically',
		description: 'Title of the Jira Triage Agent recommendation message',
	},
	description: {
		id: 'jira-triage-agent-recommendation.description',
		defaultMessage:
			'Jira Triage Agent reviews incoming work to flag duplicates and suggest fields like assignee, priority and labels, as soon as they land. <learnMore>See how it works.</learnMore>',
		description:
			'Body copy explaining what the Jira Triage Agent does. <learnMore> wraps the text of an inline button that opens an explanation of the agent; it may be repositioned within the sentence but must be kept.',
	},
	setUpIn: {
		id: 'jira-triage-agent-recommendation.set-up-in',
		defaultMessage: 'Set up in {projectName}',
		description: 'Primary action label; sets up the Triage Agent in the selected project',
	},
	chooseProject: {
		id: 'jira-triage-agent-recommendation.choose-space',
		defaultMessage: 'Choose a space',
		description: 'Accessible label for the space chooser dropdown',
	},
	dismiss: {
		id: 'jira-triage-agent-recommendation.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Accessible label for the dismiss (close) button',
	},
});
